import type { FeedbackCitationSummary } from "../types";

/** Compact citation label for list rows. */
export function formatCitationSummary(
  citations?: FeedbackCitationSummary[],
): string {
  if (!citations?.length) {
    return "—";
  }

  if (citations.length === 1) {
    const citation = citations[0];
    return citation.doc_name ?? citation.doc_id;
  }

  return `${citations.length} citations`;
}
